import fs from 'node:fs'
import path from 'node:path'
import type { GeneratedFile } from '@core-engine/schema/types.js'
import { normalizeLineEndings, snapshotTargetPath } from '@core-engine/snapshots/store.js'
import { mergeDiff3 } from 'node-diff3'

export interface MergeOutput {
  file: GeneratedFile
  conflict: boolean
}

function splitLines(content: string): string[] {
  return normalizeLineEndings(content).split('\n')
}

export function mergeGeneratedFile(
  base: GeneratedFile,
  localContent: string,
  remote: GeneratedFile
): MergeOutput {
  const merged = mergeDiff3(
    splitLines(localContent),
    splitLines(base.content),
    splitLines(remote.content),
    {
      excludeFalseConflicts: true,
      label: {
        a: 'LOCAL',
        o: 'BASE',
        b: 'REMOTE'
      }
    }
  )

  return {
    file: {
      path: remote.path,
      content: merged.result.join('\n')
    },
    conflict: merged.conflict
  }
}

export function writeProjectFile(cwd: string, file: GeneratedFile): void {
  const outputPath = snapshotTargetPath(cwd, file.path)
  fs.mkdirSync(path.dirname(outputPath), { recursive: true })
  fs.writeFileSync(outputPath, file.content, 'utf-8')
}

export function readProjectFile(cwd: string, filePath: string): string | null {
  const fullPath = snapshotTargetPath(cwd, filePath)
  if (!fs.existsSync(fullPath)) {
    return null
  }

  return fs.readFileSync(fullPath, 'utf-8')
}

export function deleteProjectFile(cwd: string, filePath: string): void {
  fs.rmSync(snapshotTargetPath(cwd, filePath), { force: true })
}

export function hasConflictMarkers(content: string): boolean {
  return /^(<{7}|={7}|>{7})( |$)/m.test(content)
}
